import { render } from "./UseAsGuestButton.vue?vue&type=template&id=73867988"
import script from "./UseAsGuestButton.vue?vue&type=script&lang=js"
export * from "./UseAsGuestButton.vue?vue&type=script&lang=js"
script.render = render

export default script